<template>
  <div>
    <b-row>
      <b-col class="col-md-3 col-12 mt-1">
        <h5>{{$t('contact.title')}}</h5>

        <b-card no-body class="border-0">
          <b-list-group >
            <b-list-group-item>
              <b-row class="justify-content-between align-items-center">
                <b-col md="4" class="d-flex align-items-center">
                  <div>
                    <feather-icon icon="HomeIcon" size="16" />
                  </div>
                  <span class="ml-50">{{$t('company_name')}}</span>
                </b-col>
                <b-col md="8" class="text-right">
                  <span>{{ GET_ALL_CONTACTS.company_name }}</span>
                  <feather-icon
                    v-b-modal.modal-detail-contact
                    icon="Edit3Icon"
                    class="text-warning ml-1"
                    size="15"
                  />
                </b-col>
              </b-row> 
            </b-list-group-item>

            <b-list-group-item>
              <b-row class="justify-content-between align-items-center">
                <b-col md="4" class="d-flex align-items-center">
                  <div>
                    <feather-icon icon="MessageCircleIcon" size="16" />
                  </div>
                  <span class="ml-50">{{$t('description')}}</span>
                </b-col>
                <b-col md="8" class="text-right">
                  <span>
                    {{GET_ALL_CONTACTS.description}}
                  </span>
                </b-col>
              </b-row>  
            </b-list-group-item>

             <b-list-group-item>
              <b-row class="justify-content-between align-items-center">
                <b-col md="4" class="d-flex align-items-center">
                  <div>
                    <feather-icon icon="MapPinIcon" size="16" />
                  </div>
                  <span class="ml-50">{{$t('address')}}</span>
                </b-col>
                <b-col md="8" class="text-right">
                  <span>
                    {{GET_ALL_CONTACTS.address}}
                  </span>
                </b-col>
              </b-row>  
            </b-list-group-item>

            <b-list-group-item>
              <b-row class="justify-content-between align-items-center">
                <b-col md="4" class="d-flex align-items-center">
                  <div>
                    <feather-icon icon="InfoIcon" size="16" />
                  </div>
                  <span class="ml-50">{{$t('inn')}}</span>
                </b-col>
                <b-col md="8" class="text-right">
                  <span>
                    {{GET_ALL_CONTACTS.inn}}
                  </span>
                </b-col>
              </b-row>  
            </b-list-group-item>

            <b-list-group-item>
              <b-row class="justify-content-between align-items-center">
                <b-col md="4" class="d-flex align-items-center">
                  <div>
                    <feather-icon icon="MailIcon" size="16" />
                  </div>
                  <span class="ml-50">{{$t('email')}}</span>
                </b-col>
                <b-col md="8" class="text-right">
                  <span>
                    {{GET_ALL_CONTACTS.email}}
                  </span>
                </b-col>
              </b-row>  
            </b-list-group-item>

            <b-list-group-item>
              <b-row class="justify-content-between align-items-center">
                <b-col md="4" class="d-flex align-items-center">
                  <div>
                    <feather-icon icon="PhoneCallIcon" size="16" />
                  </div>
                  <span class="ml-50">{{$t('phone')}}</span>
                </b-col>
                <b-col md="8" class="text-right">
                  <span>
                    {{GET_ALL_CONTACTS.phone_number}}
                  </span>
                </b-col>
              </b-row>  
            </b-list-group-item>

          </b-list-group>
        </b-card>

        <h5>{{$t('contact.kontragent')}}</h5>

        <div v-if="GET_ALL_CONTACTS && GET_ALL_CONTACTS.contact_agent && GET_ALL_CONTACTS.contact_agent.length === 0">
          <p class="empty__text">
            {{ $t("empty_text") }}
          </p>
        </div>

        <b-card
          v-for="item in GET_ALL_CONTACTS.contact_agent"
          :key="item.id"
          class="border-0 mb-1"
          no-body
        >
          <b-list-group>
            <b-list-group-item>
              <b-row class="justify-content-between align-items-center">
                <b-col md="4" class="d-flex align-items-center">
                  <div>
                    <feather-icon icon="UserIcon" size="16" />
                  </div>
                  <span class="ml-50">{{$t('name')}}</span>
                </b-col>
                <b-col md="8" class="text-right">
                  <span>{{ item.name }}</span>

                  <feather-icon
                    v-b-modal.modal-contractor-id
                    icon="Edit3Icon"
                    class="text-warning ml-1"
                    size="15"
                    @click="editContactAgent = item"
                  />
                </b-col>
              </b-row> 
            </b-list-group-item>

            <b-list-group-item>
              <b-row class="justify-content-between align-items-center">
                <b-col md="4" class="d-flex align-items-center">
                  <div>
                    <feather-icon icon="AwardIcon" size="16" />
                  </div>
                  <span class="ml-50">{{$t('position')}}</span>
                </b-col>
                <b-col md="8" class="text-right">
                  <span class="text-right w-80">{{ item.position }}</span>
                </b-col>
              </b-row>  
            </b-list-group-item>
            
            <b-list-group-item>
              <b-row class="justify-content-between align-items-center">
                <b-col md="4" class="d-flex align-items-center">
                  <div>
                    <feather-icon icon="SmartphoneIcon" size="16" />
                  </div>
                  <span class="ml-50">{{$t('phone')}}</span>
                </b-col>
                <b-col md="8" class="text-right">
                  <span class="text-right w-80">{{ item.phone_number }}</span>
                </b-col>
              </b-row>  
            </b-list-group-item>
          </b-list-group>
        </b-card>

        <b-button
          v-b-modal.modal-contractor-id
          class="float-right"
          variant="success"
          size="sm"
          @click="editContactAgent = {}"
        >
          <feather-icon icon="PlusIcon" size="18" />
        </b-button>
      </b-col>

      <b-col class="col-md-9 col-12">
        <div class="d-flex align-items-center justify-content-between mb-50">
          <h5 class="mb-0 mt-50">{{$t('sidebar.agreements')}}</h5>
          <comments
            :content-type="getContentType"
            :object-id="$route.params.id"
          />
        </div>

        <b-card no-body class="py-1">
          <b-table :items="GET_ALL_CONTACT_CONTRACTS" :fields="fields" responsive hover>

            <template #head()="props">
              <span>{{ $t(props.label) }}</span>
            </template>

            <template #cell(created_at)="props">
              <span>{{ props.item.created_at }}</span>
            </template>
         
            <template #cell(contract_number)="props">
              <span>{{ props.item.contract_number }}</span>
            </template>
            
            <template #cell(goods)="props">
              <b-badge
                class="mb-25 ml-1"
                v-for="(item, index) in props.item.goods"
                :key="index"
              >
                {{ item && item[0] }}
              </b-badge>
            </template>

            <template #cell(intruments)="props">
              <b-badge
                class="mb-25 ml-1"
                v-for="(item, index) in props.item.intruments"
                :key="index"
              >
                {{ item && item[0] }}
              </b-badge>
            </template>
            
            <template #cell(amount)="props">
              <span>{{ $_formatPriceMixin(props.item.amount) }}</span>
            </template>
            
            <template #cell(status)="props">
              <span>{{ props.item.status.full_name }}</span>
            </template>
            
            <!-- <template #cell(actions)>
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  size="sm"
                  variant="warning"
                >
                  <feather-icon icon="EditIcon" size="15" />
                </b-button>
              </div>
            </template> -->
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <contactDetailModal />

    <contractorModal :edit-contact-agent="editContactAgent" />
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BListGroup,
  BListGroupItem,
  BRow,
  BTable,
  BBadge,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import comments from "./sidebarComments.vue";
import contactDetailModal from "./modals/contactDetailModal.vue";
import contractorModal from "./modals/contractorModal.vue";
import contentType from "@/utils/contentTypes";
import loader from "@/mixins/loader";
import priceFormatMixin from "@/mixins/priceFormatMixin";

export default {
  name: "DetailContact",
  components: {
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    BButton,
    BCard,
    BTable,
    BBadge,
    comments,
    contactDetailModal,
    contractorModal,
  },
  directives: {
    Ripple,
  },
  mixins: [loader, priceFormatMixin],
  data() {
    return {
      fields: [
        // {
        //   label: "№",
        //   key: "id",
        // },
        {
          label: "date",
          key: "created_at",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "сontract_number",
          key: "contract_number",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "reference.material",
          key: "goods",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "reference.instrument",
          key: "intruments",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "sum",
          key: "amount",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "status",
          key: "status",
          thClass: "text-center",
          tdClass: "text-center",
        },
        // {
        //   label: "actions",
        //   key: "actions",
        //   thClass: "text-right",
        //   tdClass: "text-right",
        // },
      ],
      editContactAgent: {},
      items: [
      ],
    };
  },
  computed: {
    ...mapGetters("contacts", ["GET_ALL_CONTACTS", "GET_CONTACT_AGENT", "GET_ALL_CONTACT_CONTRACTS"]),

    getContentType() {
      return contentType["contacts/contact"];
    },
  },
  async mounted() {
    await this.$_loaderStart();
    await this.FETCH_ALL_CONTACTS_LIST_ID(this.$route.params.id);
    await this.FETCH_ALL_CONTACTS_CONTRACTS_BY_ID(this.$route.params.id);
  },
  async beforeRouteLeave(to, from, next) {
    await this.$_loaderStop();
    next();
  },
  methods: {
    ...mapActions("contacts", ["FETCH_ALL_CONTACTS_LIST_ID", "FETCH_ALL_CONTACTS_CONTRACTS_BY_ID"]),
  },
};
</script>

<style>
.treaty th {
  vertical-align: middle !important;
}

.w-80 {
  width: 80%;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.empty__text {
  padding: 50px;
  text-align: center;
  border: 1px dashed #ccc;
  border-radius: 5px;
}
</style>
